import React, { Component } from 'react';
import get from 'lodash.get';
import { AutocompleteType, ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as SearchIcon } from '../../../../resources/assets/components/DLS_Search.svg';
import { Button } from '../../button/button.js';
import { Input } from '../../input/input.js';
import { Loader } from '../../loader/loader.js';
import { LocatorModal } from './locator-modal.js';
import './locator-input.css';
class LocatorInput extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.openModal = () => {
            const { readOnly } = this.props;
            if (readOnly) {
                return;
            }
            this.setState({ open: true });
        };
        this.onChange = ({ prettyValue, value }) => {
            const { displayProp, onChange } = this.props;
            if (isFunction(onChange)) {
                onChange(new ChangeEvent({
                    entry: displayProp,
                    oldValue: get(value, displayProp),
                    prettyValue,
                    value,
                }));
            }
        };
        this.onCloseModal = () => {
            this.setState({ open: false });
        };
        this.onSubmit = (event) => {
            const { onSubmit } = this.props;
            this.setState({ open: false });
            if (isFunction(onSubmit)) {
                onSubmit(event);
            }
        };
    }
    /**
     * Prettifies a given value.
     *
     * @param properties - Properties to generate pretty value.
     */
    static formatPrettyValue(properties) {
        const { value, displayProp } = properties;
        return get(value, displayProp);
    }
    renderModal() {
        const { contextData, fragment, modalType } = this.props;
        const locatorModal = {
            contextData,
            fragment,
            modalType,
            onClose: this.onCloseModal,
            onSubmit: this.onSubmit,
        };
        return (React.createElement(LocatorModal, { ...locatorModal }));
    }
    renderButton() {
        const { enabled, loading, readOnly } = this.props;
        if (loading || readOnly) {
            return null;
        }
        return (React.createElement(Button, { className: "c-locator-search__button", enabled: enabled, icon: React.createElement(SearchIcon, { className: "c-locator-search__icon" }), onClick: this.openModal, theme: ButtonTheme.SECONDARY, value: "" }));
    }
    renderLoader() {
        const { loading } = this.props;
        if (!loading) {
            return null;
        }
        return (React.createElement("div", { className: "c-locator__loader" },
            React.createElement(Loader, { centered: true, className: "c-locator-loader-icon", size: 32 })));
    }
    renderInput() {
        const { displayProp, enabled, inputEnabled, onBlur, onFocus, placeholder, readOnly, sensitiveData, strikethrough, value } = this.props;
        const inputProps = {
            autoComplete: AutocompleteType.OFF,
            autoCorrect: false,
            className: 'c-locator-input__input',
            enabled: inputEnabled && enabled,
            onBlur,
            onChange: this.onChange,
            onFocus,
            placeholder: !readOnly ? placeholder : '',
            readOnly,
            sensitiveData,
            strikethrough,
            value: get(value, displayProp),
        };
        return (React.createElement("div", { className: "c-locator-input__input-wrapper" },
            React.createElement(Input, { ...inputProps }),
            this.renderButton(),
            this.renderLoader()));
    }
    render() {
        const { className, readOnly } = this.props;
        const { open } = this.state;
        const wrapperClassName = classNames({
            'c-locator-input': true,
            [`${className}`]: Boolean(className),
        });
        return (React.createElement("div", { className: wrapperClassName },
            this.renderInput(),
            open && !readOnly && this.renderModal()));
    }
}
export { LocatorInput, };
//# sourceMappingURL=locator-input.js.map